module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-25-min.9ded4b78.jpg";